<template>
    <div class="tabPaneConrtent-card" @click="viewDetails">
        <div class="tabPaneConrtent-card-content">
            <div class="tabPaneConrtent-card-content-img">
                <img :src="imgUrl" alt="" style="width: 100%;
height: auto;">
            </div>
        </div>
        <div class="tabPaneConrtent-card-content-box">
            <div class="tabPaneConrtent-card-content-title ">{{ item.input988275a1 }}</div>
            <div class="tabPaneConrtent-card-content-jianjie">{{ item.inputefdc72c4 }}</div>
            <div class="tabPaneConrtent-card-content-box-bottom">
                <div class="tabPaneConrtent-card-content-box-bottom-left">
                    <span>作者:</span><span>{{ item.inputf810f6db }}</span> <span>时间:</span><span>{{ item.date2f1ad95c
                        }}</span>
                </div>
                <div class="tabPaneConrtent-card-content-xiangqing" @click="viewDetails">查看详情</div>
            </div>

        </div>
    </div>
</template>

<script setup>

import { computed } from 'vue'
const props = defineProps({
    item: {
        type: Object,
        default: () => ({}),
    }
})

const emit = defineEmits(['viewDetails'])

const getImgUrl = (item) => {
    if (item['picture-uploadc1d6988a'] && item['picture-uploadc1d6988a'].length > 0) {
        return item['picture-uploadc1d6988a'][0].url
    } else {
        return ""

    }
}


const item = computed(() => {
    return props.item
})

const imgUrl = computed(() => {
    return getImgUrl(props.item)
})

const viewDetails = () => {
    emit('viewDetails', item.value)
}
</script>

<style scoped lang="less">
.tabPaneConrtent-card {
    width: 99%;
    height: 170px;
    box-shadow: 0px 1px 5px 0px rgba(185, 196, 218, 0.4);
    margin-bottom: 30px;
    margin-top: 10px;
    margin-right: 10px;
    margin-left: 10px;
    border-radius: 5px;
    display: flex;
    font-family: 'PuHuiTi';
    cursor: pointer;
}

.tabPaneConrtent-card:hover {
    box-shadow: 0px 2px 8px 0px rgba(185, 196, 218, 0.80);
}


.tabPaneConrtent-card-content {
    width: 300px;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 10px;
    border-radius: 5px;
    overflow: hidden;

}

.tabPaneConrtent-card-content-title {
    color: rgba(51, 51, 51, 1);
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}

.tabPaneConrtent-card-content-img {
    width: 270px;
    height: 115px;
    overflow: hidden;
    border-radius: 8px;
}

.tabPaneConrtent-card-content-box {
    flex: 1;
    height: 100%;
    padding-right: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
}

.tabPaneConrtent-card-content-title {
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    width: 100%;
    text-align: left;

    margin-top: 20px;

}

.tabPaneConrtent-card-content-jianjie {
    padding: 10px 0px;
    width: 100%;
    height: 53px;
    text-align: left;
    font-size: 14px;
    color: rgba(92, 95, 101, 1);
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}

.tabPaneConrtent-card-content-xiangqing {
    margin-top: 5px;
    margin-left: 10px;
    display: inline-block;
    padding: 3px 10px;
    color: rgba(32, 129, 235, 1);
    cursor: pointer;
    // border: 1px solid rgba(153, 153, 153, 0.3);
}



.tabPaneConrtent-card-content-box-bottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 20px;

}

.tabPaneConrtent-card-content-box-bottom-left {
    color: rgba(152, 157, 167, 1);
}
</style>